import React, { useState, useEffect, useRef } from "react";
import homeImage1 from "../assets/img/welcome-img.svg";
import playstore from "../assets/img/playstore.svg";
import register from "../assets/img/why-onezapp.svg";
import Mouse from "../assets/img/mouse.svg";
import image1 from "../assets/img/how-to-onezapp-1.png";
import image2 from "../assets/img/how-to-onezapp-2.png";
import image3 from "../assets/img/how-to-onezapp-3.png";
import { Rings } from "react-loader-spinner";
import Slider from "react-slick";
import { homeContent } from "../utils/routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import parse from "html-react-parser";

function Home() {
  // const [sliderInView, setSliderInView] = useState(false);
  // const [scrollPause, setScrollPause] = useState(false);
  const howToOneZappSliderRef = useRef(null);
  const howToOneZappSliderRefDiv = useRef(null);

  const settings = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    dots: true,
    speed: 2000,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    pauseOnDotsHover: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          arrows: true,
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const htoSliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    verticalSwiping: true,
    vertical: true,
    pauseOnHover: true,
    pauseOnDotsHover: true,
  };
  const [home, setHome] = useState({
    all_you_need_to_do_is: "",
    why_onezapp: "",
    all_you_need_to_do_is_description: "",
    download_onezapp_app: "",
    download_onezapp_app_url: "",
    how_to_onezapp: "",
    how_to_onezapp_description: "",
    make_payment_seemless: "",
    onezapp_customers: "",
    onezapp_customers_cards: "",
    onezapp_customers_description: "",
    make_payment_seemless: "",
    make_payment_seemless_description: "",
    onezapp_services: "",
    onezapp_service_description: "",
  });

  const [cardsService, setCardsService] = useState({});
  const [cardsCustomers, setCardsCustomers] = useState({});
  const [doList, setDoList] = useState({});
  const [functionalities, setFunctionalities] = useState({});
  const [loading, setLoading] = useState(true);

  const onScrollSlide = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.deltaY > 0) {
      howToOneZappSliderRef.current.slickNext();
    } else {
      howToOneZappSliderRef.current.slickPrev();
    }
  };

  useEffect(() => {
    if (howToOneZappSliderRefDiv && howToOneZappSliderRefDiv.current) {
      howToOneZappSliderRefDiv.current.addEventListener("wheel", (e) => {
        onScrollSlide(e);
      });
    }
  }, []);

  useEffect(() => {
    setLoading(true);

    var pageId = {
      id: 1,
    };

    const getUserRequestDTO = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(pageId),
    };

    fetch(homeContent, getUserRequestDTO)
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);

        var serviceCards = JSON.parse(data.msg.onezapp_service_cards);

        var customerCards = JSON.parse(data.msg.onezapp_customers_cards);

        var allDoList = JSON.parse(data.msg.all_you_need_to_do_is_description);

        var onezappFunctionalities = JSON.parse(
          data.msg.why_onezapp_functionalities
        );

        setHome(data.msg);
        setCardsService({ serviceCards });
        setCardsCustomers({ customerCards });
        setDoList({ allDoList });
        setFunctionalities({ onezappFunctionalities });
      });
  }, []);

  return (
    <div className="displayWeb" style={{ overflow: "hidden" }}>
      <div className={loading === true ? "overlay" : " "}>
        <p id="loading">
          {loading ? <Rings color="#91298c" height={160} width={160} /> : null}
        </p>
      </div>
      <section className="section section-welcome">
        <div className="container">
          <div className="row g-3 align-items-center">
            <div className="col-md-6 pt-5 ">
              <div className="section-title">
                <h1>{parse(home.make_payment_seemless)}</h1>
                <p>{home.make_payment_seemless_description}</p>
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.epSystems.oneZap.android.app"
                  className="btn btn-home-download-zapp mt-2"
                >
                  {home.download_onezapp_app}
                  <img className="home__playbutton" src={playstore}></img>
                </a>
              </div>
            </div>
            <div className="col-md-6 order-first order-md-last">
              <img src={homeImage1} className="img-responsive img-fluid" />
            </div>
            <div className="col-12 d-xl-block d-lg-none order-last">
              <center className="my-5">
                <a href="#section" className="web">
                  <img src={Mouse} />
                  <p style={{ display: "inline" }} className="home__scrolldown">
                    &nbsp;&nbsp;Scroll down
                  </p>
                </a>
              </center>
            </div>
          </div>
        </div>
      </section>

      <section className="section our-services pt-md-0">
        <div className="container">
          <div className="section-title">
            <h1>{parse(home.onezapp_services)}</h1>
            <p>{home.onezapp_service_description}</p>
          </div>
          <Slider {...settings}>
            {cardsService?.serviceCards?.map((service, index) => {
              return (
                <div className="card card-service mt-2">
                  <div className="d-flex align-items-center">
                    <img src={require(`../assets/img/${service.img}`)} />
                    <h3>{service.heading}</h3>
                  </div>
                  <p>{service.desc}</p>
                </div>
              );
            })}
          </Slider>
        </div>
      </section>
      <section className="section our-customers">
        <div className="container">
          <div className="section-title">
            <h1>{parse(home.onezapp_customers)}</h1>
            <p>{home.onezapp_customers_description}</p>
          </div>
          <Slider {...settings}>
            {cardsCustomers?.customerCards?.map((customer, index) => {
              return (
                <div className="card card-customer mt-2" key={index}>
                  <div className="d-flex align-items-center">
                    <img
                      className="home__customer__cards__img__agent "
                      src={require(`../assets/img/${customer.img}`)}
                    />
                    <h3>{customer.heading}</h3>
                  </div>
                  <p>{customer.desc}</p>
                </div>
              );
            })}
          </Slider>
        </div>
      </section>

      <section
        className="how-to-zapp"
        onMouseOver={() => {
          howToOneZappSliderRef.current.slickPlay();
        }}
      >
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-sm-12">
              <div className="section-title">
                <h1>{parse(home.how_to_onezapp)}</h1>
                <p className="">{home.how_to_onezapp_description}</p>
              </div>
              <div className="text-block">
                <h5>{parse(home.all_you_need_to_do_is)}</h5>
                <ol className=" mt-4 w-100">
                  {doList?.allDoList?.map((list, index) => {
                    return <li>{parse(list.desc)}</li>;
                  })}
                </ol>
                <div className="btn-wrap w-100">
                  <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=com.epSystems.oneZap.android.app"
                    className="btn btn-home-download-zapp mt-5"
                  >
                    {home.download_onezapp_app}
                    <img className="home__playbutton" src={playstore}></img>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 order-last order-md-last">
              <div ref={howToOneZappSliderRefDiv}>
                <Slider
                  ref={howToOneZappSliderRef}
                  className="slider-wrapper"
                  {...htoSliderSettings}
                >
                  <div className="img-wrap">
                    <img
                      className="img-fluid img-responsive"
                      src={image1}
                    ></img>
                  </div>
                  <div className="img-wrap">
                    <img
                      className="img-fluid img-responsive"
                      src={image2}
                    ></img>
                  </div>
                  <div className="img-wrap">
                    <img
                      className="img-fluid img-responsive"
                      src={image3}
                    ></img>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section why-onezapp">
        <div className="container">
          <div className="section-title">
            <h1>{parse(home.why_onezapp)}</h1>
            <p className="">{home.why_onezapp_description}</p>
          </div>
          <div className="row align-items-center">
            <div className="col-md-6 col-sm-12 ">
              {functionalities?.onezappFunctionalities?.map(
                (functionality, index) => {
                  return (
                    <ol>
                      <h5>
                        <span>
                          <b>0{functionality.orderNum}</b>{" "}
                        </span>{" "}
                        <b>{functionality.heading}</b>
                      </h5>
                      <p>{functionality.desc}</p>
                    </ol>
                  );
                }
              )}
            </div>

            <div className="col-md-6 col-sm-12 order-first order-md-last ">
              <center>
                <img className="img-fluid img-responsive " src={register}></img>
              </center>
            </div>
          </div>
        </div>
      </section>

      <div className="main" id="section"></div>
    </div>
  );
}

export default Home;
